import script from "./QueryInput.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryInput.vue?vue&type=script&setup=true&lang=js"

import "./QueryInput.vue?vue&type=style&index=0&id=61766b0e&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61766b0e"]])

export default __exports__